import type { MessageKey } from 'types/LocaleMessageKey';

import { _getDiscountAppliedMessage } from './_getDiscountAppliedMessage';
import { _getNoDiscount } from './_getNoDiscount';
import type { DiscountError, GetDiscountMessage } from './types';

const getDiscountMessage = ({
  appliedDiscountCode,
  campaign,
  discount,
  discountIsLoading,
  discountIsSuccess,
  promotionCodes,
  showHighestDiscountEyebrow,
  showUrlDiscount,
  statsigDiscountArray,
  urlPromotionData,
}: GetDiscountMessage): MessageKey | null => {
  const invalidReason = discount?.content?.discount?.invalidReason ?? null;

  let discountError: DiscountError = {
    errorMessage: null,
    invalidReason,
  };

  const hasDiscountResolved =
    (appliedDiscountCode || campaign) &&
    !discountIsLoading &&
    discountIsSuccess;

  if (hasDiscountResolved) {
    // check if discount is not valid
    discountError = _getNoDiscount({
      discount,
      invalidReason,
      valid: discount?.content?.discount?.valid,
    });
  }

  const { errorMessage, invalidReason: reason } = discountError;

  return _getDiscountAppliedMessage({
    appliedDiscountCode,
    campaign,
    errorCode: urlPromotionData?.cartSavePromotion.errorCode,
    errorMessage,
    discountError,
    showHighestDiscountEyebrow,
    promotionCodes,
    reason,
    showUrlDiscount,
    statsigDiscountArray,
  });
};

export default getDiscountMessage;
